<div #tableContainer class="table-container">
  <nz-table #dynamicTable [nzScroll]="{ x: getScrollX, y: scrollY || '70vh' }" [nzData]="dataFiltered"
    class="table-dynamic" [nzTableLayout]="settingValue.tableLayout || 'auto'" [nzBordered]="settingValue.bordered"
    [class.vss-empty-table]="!dataFiltered?.length" [nzSimple]="settingValue.simple" [nzFrontPagination]="false"
    [nzShowPagination]="false" [nzFooter]="settingValue.footer ? settingValue.footer : null"
    [nzTitle]="settingValue.title ? settingValue.title : null" [nzSize]="settingValue.size"
    (nzCurrentPageDataChange)="currentPageDataChange($event)"
    [nzPageSizeOptions]="settingValue.pagination === true ? [10,20,50,100] : []" [nzNoResult]="noData"
    [nzLoading]="isLoading">
    <thead>
      <tr [hidden]="true">
        <th [scope]="scope" *ngIf="settingValue.checkbox" nzWidth="30px" [(nzChecked)]="allChecked"
          [nzLeft]="fixedColumn" [nzIndeterminate]="indeterminate" (nzCheckedChange)="checkAllItem($event)"
          [nzDisabled]="isCheckDisable"></th>
        <ng-container *ngFor="let col of tableColumnData">
          <th [scope]="scope" [nzLeft]="col?.pxLeft! ? col?.pxLeft! : false" [nzWidth]="col.width || 'auto'"
            [nzRight]="col?.pxRight! ? (showSettingCol() ? getPxRightAddSetting(col?.pxRight! || '0') : col?.pxRight!) : false"
            class="text-center text-nowrap" *ngIf="col.checked">
          </th>
        </ng-container>
        <th *ngIf="showSettingCol()" [nzWidth]="widthSetting + 'px'" scope="col"></th>
      </tr>
      <tr *ngFor="let item of tableHeads; let indexRowTh = index" cdkDropList cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="dropCol($event, item)" [cdkDropListDisabled]="!isReOrderColumn">
        <th [scope]="scope" *ngIf="settingValue.checkbox && indexRowTh == 0" [attr.rowspan]="tableHeads.length"
          nzWidth="30px" [(nzChecked)]="allChecked" [nzLeft]="fixedColumn" [nzIndeterminate]="indeterminate"
          (nzCheckedChange)="checkAllItem($event)" [nzDisabled]="isCheckDisable"></th>
        <ng-container *ngFor="let col of item">
          <th [scope]="scope" [nzWidth]="col.width || 'auto'" cdkDrag [nzLeft]="col?.pxLeft! ? col?.pxLeft! : false"
            [nzRight]="col?.pxRight! ? (showSettingCol() ? getPxRightAddSetting(col?.pxRight! || '0') : col?.pxRight!) : false"
            [attr.rowspan]="col.isHideChildren ? 0 : !col?.children?.length ? tableHeads.length - indexRowTh : 1"
            [attr.colspan]="col.isHideChildren ? 1 : !col?.children?.length ? 1 : col?.children?.length"
            class="text-left text-nowrap" *ngIf="col.checked && !col.isHidden" nzPreview nz-resizable
            (nzResizeEnd)="onResize($event,col.name)">
            <div class="grid-th" [nz-tooltip]="col.attr | translate" *ngIf="!col.hiddenTitle">
              <div [class]="col?.isLeftHeader ? 'grid-th--content-left' : 'grid-th--content'"
                [class.ellipsis-none]="col?.disableEllipsisTH" cdkDragHandle>
                <ng-container *ngIf="isPreview; else colNameTemplate">
                  <ng-container *ngIf="!col?.isEditColAttr; else editColTemplate">
                    <span (click)="col!.isEditColAttr = true">{{col.attr | translate}}</span>
                  </ng-container>
                  <ng-template #editColTemplate>
                    <input nz-input type="text" class="input-edit" (keyup.enter)="onChangeColAttrValue(col)"
                      (blur)="onChangeColAttrValue(col)" [placeholder]="col.name | translate" [(ngModel)]="col.attr"
                      [ngModelOptions]="{standalone: true}">
                  </ng-template>
                </ng-container>
                <ng-template #colNameTemplate>
                  <label class="text-center" nz-checkbox *ngIf="col.name === 'kcsResult' && isCheckboxHeader === true"
                    (nzCheckedChange)="onChangeCheckedHeader($event)" [(nzChecked)]="allCheckedKCS"
                    [nzDisabled]="disabelBtnKCS">
                  </label>
                  {{col.attr | translate}}
                  <a *ngIf="col.isSort" class="grid-th--icon" [class.active]="sortField[col.name]"
                    (click)="sortData(col.name)">
                    <i nz-icon nzType="arrow-down" nzTheme="outline" *ngIf="sortField[col.name] !== 'desc'"
                      aria-hidden="true"></i>
                    <i nz-icon nzType="arrow-up" nzTheme="outline" *ngIf="sortField[col.name] === 'desc'"
                      aria-hidden="true"></i>
                  </a>
                </ng-template>

              </div>

              <a *ngIf="indexRowTh === 0 && col?.children?.length && col?.allowToggleChildren" class="grid-th--icon"
                [class.active]="sortField[col.name]" (click)="toggleChildHeader(col)">
                <i nz-icon [nzType]="col.isHideChildren ? 'step-forward' : 'step-backward'" nzTheme="outline"
                  aria-hidden="true"></i>
              </a>
            </div>
            <nz-resize-handle nzDirection="right"
              [class.d-none]="(col.hiddenResize && !isResizeAll) || col.children?.length">
              <div class="resize-trigger"></div>
            </nz-resize-handle>
            <!-- filter chính ở đây -->
            <div class="grid-th" *ngIf="!isHaveFilterHeader">
              <div class="grid-th--content">
                <ng-container [ngSwitch]="col.filter?.type" *ngIf="col.isFilter && isFilter">
                  <ng-container *ngSwitchCase="COLUMN_TYPE.CHECKBOX">
                    <label nz-checkbox
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [nzDisabled]="col.isDisabled" (change)="onFilter()">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.INPUT_NUMBER">
                    <input inputNumber class="w-100" nz-input type="text"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [placeholder]="placeholderSearch | translate" #inputInputNumberRef
                      [maxlength]="col?.filter?.maxLength || col.maxlength || 18"
                      [maxLengthNumber]="col?.filter?.maxLength || col.maxlength || 18"
                      (keyup)="filterOnPress && onFilter(); onChangeInputSearch(COLUMN_TYPE.INPUT_NUMBER)"
                      (keyup.tab)="onFilter()" (keyup.enter)="onFilter()">
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.INT">
                    <input inputNumber class="w-100" nz-input type="text" [attr.maxlength]="col.maxlength!"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [placeholder]="placeholderSearch | translate" #inputIntRef vssUiAutoCplControl
                      [vssUiAutocomplete]="col.filter?.name || col.name"
                      [disabledAutoComplete]="true || !(col.filter?.name || col.name).includes('phone') && !(col.filter?.name || col.name).includes('tel')"
                      [maxlength]="col?.filter?.maxLength || 4000"
                      (keyup)="filterOnPress && onFilter(); onChangeInputSearch(COLUMN_TYPE.INT)"
                      (keyup.tab)="onFilter()" (keyup.enter)="onFilter()">
                  </ng-container>
                  <ng-container *ngSwitchCase="colDateTypes.includes(col?.filter?.type!) ? col.filter?.type : -1">
                    <ng-container *ngIf="col?.type === COLUMN_TYPE.DATE_PICKER_YEAR; else otherDate">
                      <vss-ui-date-picker dateFormat [ranges]="col.rangesDate"
                        [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                        [csShowToday]="true"
                        [csRangePicker]="false"
                        [csPlaceHolder]="'YYYY'"
                        [csShowTime]="COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_PICKER == col?.filter?.type"
                        [csMode]="'year'" [csFormat]="'YYYY'" (csChange)="onFilter()">
                      </vss-ui-date-picker>
                    </ng-container>
                    <ng-template #otherDate>
                      <ng-container *ngIf="COLUMN_TYPE.DATE_RANGE_PICKER_YEAR == col?.filter?.type">
                        <vss-ui-date-picker dateFormat [ranges]="col.rangesDate"
                          [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                          [csShowToday]="true"
                          [csRangePicker]="true"
                          [csPlaceHolder]="'YYYY'"
                          [csShowTime]="false"
                          [csPlaceholder]="['YYYY', 'YYYY']"
                          [csMode]="'year'" [csFormat]="'YYYY'" (csChange)="onFilter()">
                        </vss-ui-date-picker>
                      </ng-container>
                      <ng-container *ngIf="COLUMN_TYPE.DATE_RANGE_PICKER_YEAR != col?.filter?.type">
                        <vss-ui-date-picker dateFormat
                        [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                        [csShowToday]="true"
                        [csRangePicker]="COLUMN_TYPE.DATE_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type"
                        [csShowTime]="COLUMN_TYPE.DATE_TIME_RANGE_PICKER == col?.filter?.type || COLUMN_TYPE.DATE_TIME_PICKER == col?.filter?.type"
                        (csChange)="onFilter()">
                      </vss-ui-date-picker>
                      </ng-container>

                    </ng-template>

                  </ng-container>

                  <ng-container
                    *ngSwitchCase="col?.filter?.type == COLUMN_TYPE.SELECT || col?.filter?.type == COLUMN_TYPE.SELECT_INT ? col?.filter?.type : -1">
                    <vss-ui-select-box #csSelectScrollComponent class="fix_plachoder_weight"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col?.name || 'value', col.filter?.type)]"
                      [optionList]="col?.filter?.options || []" [getOptionsApi]="col?.filter?.apiSearch!"
                      [keySearch]="col?.filter?.keySearch ||'keyword'" addressSelector
                      [asType]="col?.filter?.addressSelectorType!"
                      [asReferenceId]="filter[getKeyFilterByColName(col?.filter?.referenceColName! || '')]"
                      vssUiSelectDir
                      [selectOptionsQueryParams]="col?.filter?.referenceColName ? (filter[getKeyFilterByColName(col?.filter?.referenceColName! || '')] | parseObject : (col?.filter?.referenceColName || 'referenceCol')) : {}"
                      [selectOptionsType]="col?.filter?.selectOptionsType!"
                      [csMaxTagCount]="col?.filter?.csMaxTagCount!" [params]="col?.filter?.params!"
                      (onClose)="col?.filter?.multiple ? onFilter() : null"
                      (ngModelChange)="csSelectScrollComponent.isClose || !col?.filter?.multiple || !$event?.length ? onFilter() : null"
                      [csMode]="col?.filter?.multiple ? 'multiple' : 'default'" fieldId="userName"
                      [csPlaceHolder]="placeholderSelect | translate"
                      [csIsMultiLevel]="col?.filter?.isCsIsMultiLevel || false"
                      [csAllowClear]="col?.filter?.csAllowClear !== undefined ? col?.filter?.csAllowClear! : true"
                      [csDropdownMatchSelectWidth]="true"
                      [checknzSuffixIcon]="true"></vss-ui-select-box>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TAG">
                    <nz-select class="w-100" [nzOptions]="col.options || []"
                      [nzPlaceHolder]="placeholderSelect | translate"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]" nzShowSearch
                      nzAllowClear (ngModelChange)="onFilter()"></nz-select>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TEXTAREA">
                    <textarea rows="4" nz-input
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [placeholder]="col?.filter?.placeholder || col.attr" [attr.maxlength]="MAX_LENGTH_TEXT"
                      #inputTextareaRef (keyup)="filterOnPress && onFilter(); onChangeInputSearch(COLUMN_TYPE.TEXTAREA)"
                      (keyup.tab)="onFilter()"></textarea>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.NUMBER">

                    <input inputNumber class="w-100" nz-input type="text"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [placeholder]="placeholderInput | translate" #inputNumberRef
                      [maxlength]="col?.filter?.maxLength || col.maxlength || 18"
                      [maxLengthNumber]="col?.filter?.maxLength || col.maxlength || 18"
                      (keyup)="filterOnPress && onFilter(); onChangeInputSearch(COLUMN_TYPE.NUMBER)"
                      (keyup.tab)="onFilter()" (keyup.enter)="onFilter()">
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.RECORDING_FILE">

                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.ACTION">

                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TEXT_CENTER">
                    <input type="text" ng-trim="true" nz-input
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [placeholder]="placeholderInput | translate" [attr.maxlength]="MAX_LENGTH_TEXT"
                      #inputTextCenterRef (keyup.tab)="onFilter()"
                      (keyup)="filterOnPress && onFilter(); onChangeInputSearch(COLUMN_TYPE.TEXT_CENTER)"
                      (keyup.enter)="onFilter()" />
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.RANGE_NUMBER">
                    <vss-ui-range-number (csChange)="onFilter()" suffix="%" [classes]="'text-center'"
                      (ngModelChange)="onFilter()"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"></vss-ui-range-number>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.YEAR_RANGE">
                    <nz-range-picker nzMode="year" class="w-100"
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      (ngModelChange)="onFilter()">
                    </nz-range-picker>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.DATE_PICKER_SHOW_TIME">
                    <vss-ui-date-picker dateFormat
                      [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                      [csShowTime]="true" [timeFormat]="{ nzFormat: 'HH:mm:ss' }"
                      (csChange)="onFilter()"></vss-ui-date-picker>
                  </ng-container>

                  <ng-container *ngSwitchDefault>

                    <nz-input-group [nzPrefix]="prefixTemplateUser">
                      <input type="text" ng-trim="true" nz-input
                        [(ngModel)]="filter[getKeyFilter(col.filter?.name || col.name, col.filter?.type)]"
                        [placeholder]="placeholderInput | translate"
                        [attr.maxlength]="MAX_LENGTH_TEXT" vssUiAutoCplControl
                        [vssUiAutocomplete]="col.filter?.name || col.name" [disabledAutoComplete]="true"
                        #inputDefaultRef [attr.columnType]="col.name" (keyup.tab)="onFilter()"
                        (keyup)="filterOnPress && onFilter(); onChangeInputSearch(col.name)"
                        (keyup.enter)="onFilter()" />
                    </nz-input-group>
                    <ng-template #prefixTemplateUser><i nz-icon nzType="icons:searchQLCT"></i></ng-template>
                  </ng-container>
                </ng-container>
              </div>
              <a *ngIf="col.hiddenTitle" class="grid-th--icon" [class.active]="sortField[col.name]"
                (click)="sortData(col.name)">
                <i nz-icon nzType="caret-up" nzTheme="outline" *ngIf="sortField[col.name] !== 'desc'"
                  aria-hidden="true"></i>
                <i nz-icon nzType="caret-down" nzTheme="outline" *ngIf="sortField[col.name] === 'desc'"
                  aria-hidden="true"></i>
              </a>
            </div>
          </th>
        </ng-container>
        <th *ngIf="showSettingCol() && indexRowTh == 0" [nzWidth]="widthSetting + 'px'"
          [attr.rowspan]="tableHeads.length - indexRowTh" [nzRight]="'0px'" scope="col">
          <a nz-dropdown nzTrigger="click" (nzVisibleChange)="onChangeShowDropdownSetting($event)"
            [nzDropdownMenu]="menu" class="text-secondary" [nzClickHide]="false">
            <i nz-icon nzType="setting" nzTheme="outline" aria-hidden="true"></i>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item>
                <label nz-checkbox [(ngModel)]="allCheckedMenu" (ngModelChange)="updateAllCheckedMenu()"
                  [nzIndeterminate]="indeterminateMenu"> {{'BASE.ALL' | translate}}
                </label>
              </li>
              <nz-divider class="mt-1 mb-1"></nz-divider>
              <li nz-menu-item *ngFor="let item of columns; let indCol=index">
                <!-- <label nz-checkbox [(ngModel)]="item.checked"
                    *ngIf="item.name !== 'action'  && item.name !== 'index'"
                    (ngModelChange)="updateMenuItemChecked(indCol)"> {{item.attr
              ||
              item.name}}
              </label> -->
                <label nz-checkbox [(ngModel)]="item.checked" *ngIf="item.name !== 'action' && item.name !== 'index'"
                  (ngModelChange)="updateMenuItemChecked(indCol)"> {{(item.attr || item.name) | translate}}
                </label>
              </li>
            </ul>
          </nz-dropdown-menu>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!loadingDataTable; else loadingTpl" class="body-table" cdkDropList [cdkDropListData]="dataFiltered"
      (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!isReOrderRow">
      <!-- Danh sách dữ liệu bảng -->
      <ng-template ngFor let-data [ngForOf]="dynamicTable.data" (cdkDropListDropped)="drop($event)">
        <ng-container [ngTemplateOutlet]="rowTemplate" [ngTemplateOutletContext]="{data}"></ng-container>
        <tr cdkDrag *ngIf="data?.children?.data?.length" [nzExpand]="data.expand" class="table-child">
          <vss-ui-table [settingValue]="data.children.tableSetting || {}" [columns]="data?.children?.cols"
            [isFilter]="true" [isResizeAll]="true" (onFilterData)="onFilterInTable($event)" [isShowSetting]="false"
            [isEditRow]="data?.children?.isEditRow" (onSubmitItem)="saveEditChildren($event)"
            (onRemove)="startRemoveChild($event)" (onEditChild)="startEditChild($event)"
            [listOfData]="data?.children?.data"></vss-ui-table>
        </tr>
      </ng-template>
      <!-- Dòng dữ liệu cuối của bảng nếu có -->
      <ng-container *ngIf="lastRowData && dynamicTable.data.length > 0" [ngTemplateOutlet]="rowTemplate"
        [ngTemplateOutletContext]="{data: lastRowData}"></ng-container>

      <!-- Template của 1 row dữ liệu -->
      <ng-template #rowTemplate let-data="data" (cdkDropListDropped)="drop($event)">
        <tr cdkDrag [class]="'vss-ui-table-row ' + (data?.classRow || '')" [ngClass]="{'text-bold': data['text_bold']}"
          (click)="onClick(data)" [ngStyle]="data?.tr_style!" [class.hover-cursor]="isShowCursorPointerOnItem"
          [class.active-item]="checkSelectedItem(data)" (dblclick)="dbClickItem(data); onClick(data)"
          [class.select-row]="selectData === data.id">
          <td [nzLeft]="fixedColumn" *ngIf="settingValue.checkbox" [(nzChecked)]="data.checked" class="default-checkbox"
            (nzCheckedChange)="changeStatus(data)" [nzDisabled]="isCheckDisable || data.disabled"></td>
          <ng-container *ngFor="let col of tableColumnData; let i = index">
            <ng-container [ngTemplateOutlet]="colData" [ngTemplateOutletContext]="{col, index: i}"></ng-container>
            <!--        <ng-container *ngIf="col.children?.length">-->
            <!--          <ng-container *ngFor="let child of col.children" [ngTemplateOutlet]="colData" [ngTemplateOutletContext]="{col: child, defaultChecked: col.checked}"></ng-container>-->
            <!--        </ng-container>-->
          </ng-container>
          <ng-template #colData let-col="col" let-index="index" let-defaultChecked="defaultChecked">
            <ng-container *ngIf="!editCache[data.id]?.edit; else editTemplate">
              <ng-container *ngIf="col.checked || defaultChecked" [ngSwitch]="col.type">

                <td class="text-center" *ngIf="col.name ==='index'" [nzLeft]="col?.pxLeft! ? col?.pxLeft! : false"
                  [nzRight]="getFixRightPx(col)"
                  [attr.colspan]="showSettingCol() && index == getLastIndexColChecked() ? 2 : 1"
                  [(nzExpand)]="data.expand">{{ data[col.name]}}</td>
                <td *ngIf="col.name!=='index'" [nzEllipsis]="col.isEllipsis" [ngStyle]="col.styles!"
                  [width]="col.width || 'auto'" (click)="onClickData(data, col.name)"
                  [attr.colspan]="showSettingCol() && index == getLastIndexColChecked() ? 2 : 1"
                  [nz-tooltip]="col?.tooltip ? tooltipCol : ''" [nzTooltipPlacement]="['bottom', 'top']"
                  [class]="getDefaultTdClassByTypeCol(col.type) + ' ' + (col?.classes || '') + (data[col?.fieldClass || ''] || '')"
                  [nzLeft]="col?.pxLeft! ? col?.pxLeft! : false" [nzRight]="getFixRightPx(col)">
                  <ng-template #tooltipCol>
                    <div [innerHtml]="data[col?.tooltip || col.name] | vssSafeHtml"></div>
                  </ng-template>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.CHECKBOX">
                    <label nz-checkbox [ngModel]="data[col.name]? true : false" title="{{ data[col.name]}}"
                      class="custom-checkbox-disable">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.CHECKBOX_EDIT">
                    <label class="text-center" nz-checkbox [(ngModel)]="data[col.name]" title="{{ data[col.name]}}"
                      (ngModelChange)=" onChangeCol($event,col.name, data)" [nzDisabled]="disabelBtnKCS">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.PERCENT">
                    <div class="text-right">{{ data[col.name]}}%</div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.PERCENT_CENTER">
                    <div class="text-center">{{ data[col.name]}}%</div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.HTML">
                    <div [innerHTML]="data[col.name] | vssSafeHtml"></div>
                    <ng-container></ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.INPUT_NUMBER">
                    <div title="{{ data[col.name]}}">{{ data[col.name] | number : (col?.numberFixed != null ? '1.0-' +
                      col?.numberFixed : '1.0-2') }} {{data[col.name] >= 0 ? col.symbol :
                      ''}}</div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.INT">
                    <div class="text-center">{{ data[col.name]}}</div>
                  </ng-container>
                  <ng-container *ngSwitchCase="colDateTypes.includes(col.type!) ? col.type : -1">
                    <div title="{{ data[col.name] | date: (col.format || 'dd/MM/yyyy') || '' }} ">{{ data[col.name] |
                      date: (col.format || 'dd/MM/yyyy')
                      }}</div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.NUMBER">
                    <ng-container *ngIf="col.editable; else rowLabel">
                      <vss-ui-input-number [(ngModel)]="data[col.name]" [csMin]="col.minValue"
                        [csPrecision]="col?.numberFixed || 2" [csInputMode]="col?.typeNumber || 'numeric'"
                        inputNumber></vss-ui-input-number>

                      <!-- <vss-ui-input-number *ngIf="isChangeNumberOfRow"
                        [class]="isChangeNumberOfRow && (data.requestQuantity > data.quantity)  && col.name === 'requestQuantity' ? 'fix_border_errors_requestQuantity' : (isChangeNumberOfRow && (data?.quantityExport > data?.requestQuantity || data?.quantityExport > data?.quantity) && col.name === 'quantityExport') ? 'fix_border_errors_quantityExport'  : 'no_fix_border_errors_requestQuantity'"
                                        [(ngModel)]="data[col.name]" [csMin]="col.minValue"
                                        [csPrecision]="col?.numberFixed || 2" [csInputMode]="col?.typeNumber || 'numeric'"
                                        inputNumber (ngModelChange)="onChangeNumberOfRow($event, data, col.name )"></vss-ui-input-number>
                    <span *ngIf="isChangeNumberOfRow && (data.requestQuantity > data.quantity)  && col.name === 'requestQuantity'" style="color:var(--primary-color); font-size: 11px">
                      Số lượng yêu cầu không được lớn hơn số lượng tồn
                    </span>
                    <span *ngIf="isChangeNumberOfRow && (data?.quantityExport > data?.requestQuantity || data?.quantityExport > data?.quantity) && col.name === 'quantityExport'" style="color:var(--primary-color); font-size: 11px">
                      Số lượng xuất kho không được lớn hơn số yêu cầu hoặc số lượng tồn
                    </span> -->
                    </ng-container>
                    <ng-template #rowLabel>
                      <div title="{{ (data[col.name] | number) || '' }}"
                        [class.last-row-wrapper]="data.isLastRow && !data?.styleNomal"
                        [class.fw-500]="data?.styleNomal">
                        {{ data[col.name] | number }}
                        <span *ngIf="data.isLastRow && col.lastRowLabel" class="last-row-label">
                          {{ col.lastRowLabel }}
                        </span>
                      </div>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.LINK">
                    <a (click)="selectLink({link:data[col.name],data:data})" [nz-tooltip]="data[col.name]"
                      class="text-blue text-decoration-underline"> {{ data[col.name]}}</a>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.LINK2">
                    <a class="text-blue truncate" (click)="openLink(data)" [title]="data[col.name]">
                      {{data[col.name]}}
                    </a>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.LINK_ARRAY">
                    <button nz-button nz-popover nzType="primary" [nzPopoverContent]="dataLink">{{'BASE.VIEW_FILE' | translate}}</button>
                    <ng-template #dataLink>
                      <div *ngIf="data[col.name]?.length > 0">
                        <div *ngFor="let item of data[col.name]">
                          <a *ngIf="data[col.name]?.length > 0" [href]="item?.fileUrl"
                            class="text-blue text-decoration-underline">
                            {{item?.fileName}}
                          </a>
                        </div>
                      </div>
                      <div *ngIf="data[col.name]?.length === 0">
                        -
                      </div>
                    </ng-template>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.LINK_ARRAY2">
                    <!-- <button nz-button nz-popover nzType="primary" [nzPopoverContent]="dataLink">Xem File</button> -->
                    <!-- [href]="data[col.name][0].fileUrl" -->
                    <div class="text-center d-flex align-items-center justify-content-center"
                      *ngIf="data[col.name]?.length > 0">
                      <a class="text-blue truncate" *ngIf="data[col.name]?.length > 0"
                        (click)="openLink(data, data[col.name][0].fileUrl)" [title]="data[col.name][0].fileName">
                        {{data[col.name][0].fileName}}
                      </a>
                      <i nz-icon nzType="delete" nzTheme="outline" class="ms-2 cursor-pointer" *ngIf="col?.needDelete"
                        (click)="deleteFile(data)"></i>
                    </div>
                    <div class="text-center" *ngIf="!data[col.name]?.length">
                      -
                    </div>
                    <div class="text-right" *ngIf="data[col.name]?.length >=2">
                      <span class="view-more text-decoration-underline" (click)="openLinkedList(data, col)">{{'BASE.SEE_MORE' | translate}}</span>
                    </div>
                    <!-- <div *ngIf="data[col.name]?.length > 0">
                    <div *ngFor="let item of data[col.name]">
                      <a *ngIf="data[col.name]?.length > 0" [href]="item?.fileUrl"
                         class="text-blue text-decoration-underline">
                        {{item?.fileName}}
                      </a>
                    </div>
                  </div> -->

                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.UPLOAD_FILE">
                    <div class="upload-file">
                      <div class="d-flex flex-column align-items-center">
                        <span class="blue-text cursor-pointer" style="width: fit-content;"
                          (click)="uploadFile.click()">{{"BASE.UPLOAD_FILE" | translate}}</span>
                        <i nz-icon nzType="upload" nzTheme="outline" class="mx-2 blue-text"></i>
                        <input type="file" multiple="multiple" #uploadFile style="display: none" [accept]="acceptUpload"
                          (change)="upload(uploadFile, data)">
                        <span style="width: fit-content;">{{'BASE.MAXIMUM_FILE_SIZE' | translate}}</span>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.FILE_NAME">
                    <a class="text-blue truncate"
                      (click)="downloadFileV2(data)" [title]="data[col.name]">
                      {{data[col.name]}}
                    </a>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.FILE_NAME2">
                    <a class="text-blue truncate"
                      (click)="downloadFileV2(data)" [title]="data[col.name]">
                      {{data[col.name]}}
                    </a>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.IMG_LINK">
                    <div class="d-flex justify-content-center">
                      <img [src]="data[col.name]" alt="" class="avatar" *ngIf="data[col.name]">
                      <img [src]="'assets/images/avatar-empty.webp'" width="36px" height="36px" alt="" *ngIf="!data[col.name]">
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.DATE_PICKER_SHOW_TIME">
                    {{data[col.name]}}
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.STATUS">
                    <div class="d-flex justify-content-center"
                      *ngIf="data[col.name] !== null && data[col.name] !== undefined">
                      <span class="status-block" [ngStyle]="{
                        'background-color': data?.color?.backgroundColor
                      }">
                        <span [ngStyle]="{
                          'color': data?.color?.textColor,
                          'font-weight': 500
                        }">{{data[col.name] | translate}}</span>
                      </span>
                    </div>

                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.YEAR_RANGE">
                    <div class="d-flex justify-content-center">
                      {{data[col.name]}}
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.TAG">
                    <ng-container *ngIf="!isArray(data[col.name])">
                      <ng-container [ngTemplateOutlet]="tagTemplate"
                        [ngTemplateOutletContext]="{ tag: data[col.name] }">
                        <div [ngStyle]="col.styles!" class="text-left">
                        </div>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="isArray(data[col.name])">
                      <div class="d-flex flex-row">
                        <div [ngStyle]="col.styles!" class="text-left" *ngFor="let tag of data[col.name];let i = index">
                          <ng-container *ngIf="i < col?.csSelectSettings?.csMaxTagCount"
                            [ngTemplateOutlet]="tagTemplate" [ngTemplateOutletContext]="{ tag: tag }">
                          </ng-container>
                        </div>

                        <nz-tag [nzColor]="'transparent'" [nz-tooltip]="tooltipTag"
                          [style.border-color]="getColor(col?.options?.length ? col?.options : col?.filter?.options || [], data[col.name])"
                          style="border-radius: 16px"
                          *ngIf="data[col.name].length - col?.csSelectSettings?.csMaxTagCount > 0">
                          <span
                            [style.color]="getColor(col?.options?.length ? col?.options : col?.filter?.options || [], data[col.name])">
                            +{{data[col.name].length - col?.csSelectSettings?.csMaxTagCount}}
                          </span>
                        </nz-tag>
                        <ng-template #tooltipTag>
                          <div [innerHtml]="tooltipHidenTag(data[col.name], col) | vssSafeHtml"></div>
                        </ng-template>
                      </div>
                    </ng-container>
                    <ng-template #tagTemplate let-tag="tag">
                      <nz-tag [nzColor]="'transparent'" [nz-tooltip]="getValueTag(col?.filter.options || [], tag)"
                        [style.border-color]="getColor(col?.options?.length ? col?.options : col?.filter?.options || [], tag)"
                        style="border-radius: 16px" *ngIf="tag !== null && tag!== undefined">
                        <div class="d-inline-flex me-1">
                          <svg height="8" width="8">
                            <circle cx="4" cy="4" r="3"
                              [attr.stroke]="getColor(col?.options?.length ? col?.options : col?.filter?.options  || [], tag)"
                              [attr.fill]="getColor(col?.options?.length ? col?.options : col?.filter?.options || [], tag)" />
                          </svg>
                        </div>
                        <span
                          [style.color]="getColor(col?.options?.length ? col?.options : col?.filter?.options || [], tag)">{{
                          getValueTag(col?.filter.options || [], tag) | translate}}</span>
                      </nz-tag>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.DOT">
                    <div>
                      <div *ngIf="data[col.name] !== null && data[col.name]!== undefined">
                        <nz-badge [nzStatus]="getColor( col?.options || [], data[col.name])"
                          [nzColor]="getColor( col?.options || [], data[col.name])"
                          [nzText]="getValueTag( col?.options || [], data[col.name])"></nz-badge>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SELECT">
                    <div>{{getValueTag(col?.options || [], data[col.name])}}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SELECT_EDIT">
                    <vss-ui-select-box [(ngModel)]="data[col.name]" [optionList]="col?.options || []"
                      (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="onSelectChange($event, data); onChangeCol($event,col.name, data)"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate">
                    </vss-ui-select-box>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.FLAG">
                    <div>
                      <div *ngIf="data[col.name] !== null && data[col.name]!== undefined">
                        <i nz-icon nzType="flag" nzTheme="fill"
                          class="{{ getColor(col?.options || [], data[col.name] || 0)}}" aria-hidden="true"></i>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.ACTION">
                    <div class="list-action-table" [class.has-more]="!!col?.moreAction?.length">
                      <ng-container *ngFor="let cAction of col?.listAction || []">
                        <ng-container *ngIf="!cAction.fieldCheckShow || data[cAction.fieldCheckShow]">
                          <ng-container *ruleAuthorized="cAction.rules || []">
                            <ng-container [ngTemplateOutlet]="actionItemTpl"
                              [ngTemplateOutletContext]="{action: cAction}"></ng-container>
                            <nz-divider nzType="vertical"></nz-divider>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <!-- chỗ này là config menu action -->
                      <a *ngIf="!!col?.moreAction?.length" nz-dropdown nzTrigger="hover" [nzDropdownMenu]="menu"
                        class="text-secondary" [nzClickHide]="false">
                        <i nz-icon nzType="more" nzTheme="outline" aria-hidden="true"></i>
                      </a>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <ng-container *ngFor="let mAction of col?.moreAction || []">
                            <ng-container *ngIf="!mAction.fieldCheckShow || data[mAction.fieldCheckShow]">
                              <!-- (click)="onClickAction(data, mAction.key)" -->
                              <li nz-menu-item *ruleAuthorized="mAction.rules || []">
                                <ng-container [ngTemplateOutlet]="actionItemTpl"
                                  [ngTemplateOutletContext]="{action: mAction, showLabel: true}"></ng-container>
                              </li>
                            </ng-container>
                          </ng-container>
                        </ul>
                      </nz-dropdown-menu>
                    </div>
                  </ng-container>
                  <ng-template #actionItemTpl let-action="action" let-showLabel="showLabel">
                    <ng-template #actionTooltipTpl>
                      <div [innerHTML]="((action.tooltip | translate) || (action.label | translate) || '') | vssSafeHtml"></div>
                    </ng-template>
                    <a (click)="onClickAction(data, action.key)" [ngClass]="action.classes || ''"
                      class="action-icon d-inline-flex align-items-center" [nz-tooltip]="actionTooltipTpl">
                      <ng-container *ngIf="action.html">
                        <span [innerHTML]="action.html | vssSafeHtml"></span>
                      </ng-container>
                      <ng-container *ngIf="!action.html">
                        <i nz-icon [nzType]="action.icon" nzTheme="outline" aria-hidden="true"
                          style="font-size: 16px;"></i>
                        <!-- <img [src]="action.icon"> -->
                        <span *ngIf="showLabel" class="ms-1 label-action-text">{{ action.label | translate }}</span>
                      </ng-container>
                    </a>

                  </ng-template>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.RECORDING_FILE">
                    <div class="text-left">
                      <audio controls class="fix_W">
                        <source [src]="data[col.name]" type="">
                      </audio>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SELECT_IN_TD">
                    <vss-ui-select-box *ngIf="!isCheckDataSelectInt" [(ngModel)]="data[col.name]" class=""
                      [optionList]="col?.options || []" (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="!col?.multiple || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate">
                    </vss-ui-select-box>
                    <vss-ui-select-box *ngIf="isCheckDataSelectInt"
                      [class]="!data[col.name] && isCheckSaveAddCategoryStaff ? 'fix_border_errors' : 'no_fix_border_errors'"
                      [(ngModel)]="data[col.name]" [optionList]="col?.options || []"
                      (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="!col?.multiple || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate"
                      (csOpenChange)="csOpenChange($event, col?.options, data[col.name])">
                    </vss-ui-select-box>
                    <span *ngIf="isCheckDataSelectInt && !data[col.name] && isCheckSaveAddCategoryStaff"
                      style="color:var(--primary-color); font-size: 11px">{{'BASE.VALID_REQUIRE' | translate}}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TEXT_CENTER">
                    <div *ngIf="!col.isLink" [title]="data[col.name] || ''" class="text-center">
                      <ng-container *ngIf="col.editable; else rowLabel">
                        <input type="text" nz-input [(ngModel)]="data[col.name]"
                          (ngModelChange)="onChangeCol($event,col.name, data)" />
                      </ng-container>
                      <ng-template #rowLabel>
                        {{ data[col.name] | translate}}
                        <br>
                        {{ data[col.nameV2] | translate}}
                      </ng-template>
                    </div>
                    <div *ngIf="col.isLink"><a (click)="onClickLink(data)" class="text-blue cursor-pointer"
                        [title]="data[col.name] || ''">{{ data[col.name] }}</a></div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TEXT_LEFT">
                    <div *ngIf="!col.isLink" [title]="data[col.name] || ''" class="text-left">
                      <ng-container *ngIf="col.editable; else rowLabel">
                        <input type="text" nz-input [(ngModel)]="data[col.name]"
                          (ngModelChange)="onChangeCol($event,col.name, data)" />
                      </ng-container>
                      <ng-template #rowLabel>
                        <div class="row">
                          <div *ngIf="col.avatar" class="avatar col-5" nz-tooltip [title]="data[col.avatar]"
                            style="cursor: pointer; margin-left: 1rem; margin-top: 0.3rem;">
                            {{ getFirstChar(data[col.avatar])}}
                          </div>
                          <div [class]="col.avatar ? 'col-7' : '' ">
                            {{ data[col.name] | translate}}
                            <br>
                            {{ data[col.nameV2] | translate}}
                          </div>
                        </div>
                      </ng-template>
                    </div>
                    <div *ngIf="col.isLink"><a (click)="onClickLink(data)" class="text-blue cursor-pointer"
                        [title]="data[col.name] || ''">{{ data[col.name] }}</a></div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.ARRAY_HIDDEN">
                    <div *ngIf="data[col.name]?.length > 0" class="avatar-group">
                      <ng-container *ngFor="let item of data[col.name]; let i = index">
                        <div class="avatar" *ngIf="i < 4" nz-tooltip [title]="item?.name" style="cursor: pointer;">
                          {{ getFirstChar(item?.name)}}
                        </div>
                        <div class="avatar" *ngIf="i == 4">
                          +{{ data[col.name]?.length - 4}}
                        </div>
                      </ng-container>

                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.PROCESS">
                    <div style="text-align: center;" title="{{ data[col.name]}}">
                      <nz-progress [nzPercent]="data[col.name] || 0" nzType="circle" [nzWidth]="35"
                        nzStatus="active"></nz-progress>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.BUTTON">
                    <div class="text-center">
                      <button nz-button type="button" [nzGhost]="col?.cusButton?.isGhost"
                        [nzType]="col?.cusButton?.type" class="p-2" [title]="data[col.name] || ''"
                        (click)="onClickBtn(data)">
                        <i nz-icon [nzType]="col?.icon" aria-hidden="true"></i></button>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.ICON">
                    <div class="text-center">
                      <span [title]="data[col.name] || ''">{{data[col.name]}}</span>
                      <i nz-icon [nzType]="col?.icon" (click)="selectLink({link:data[col.name],data:data})"
                        *ngIf="data[col.name]" class="ms-2 cursor-pointer data-icon" aria-hidden="true"></i>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SWITCH">
                    <div class="text-center">
                      <nz-switch class="custom-switch" nzSize="small" [ngModel]="data[col.name]"
                        (ngModelChange)="onChangeSwitch($event, data)"></nz-switch>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SWITCH_NOT_ACTION">
                    <div class="text-center" style="pointer-events:none">
                      <nz-switch class="custom-switch" nzSize="small" [ngModel]="data[col.name]"
                        (ngModelChange)="onChangeSwitch($event, data)"></nz-switch>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div *ngIf="!col.isLink" [title]="data[col.name] || ''" [class.text-center]="(col.name === 'index')"
                      [class.last-row-wrapper]="data.isLastRow && !data?.styleNomal" [class.fw-500]="data?.styleNomal">
                      <ng-container *ngIf="col.editable; else rowLabel">
                        <input type="text" nz-input [(ngModel)]="data[col.name]"
                          (ngModelChange)="onChangeCol($event,col.name, data)" />
                      </ng-container>
                      <ng-template #rowLabel>
                        {{ data[col.name] | translate}}
                        <span *ngIf="data.isLastRow && col.lastRowLabel" class="last-row-label">
                          {{ col.lastRowLabel | translate }}
                        </span>
                      </ng-template>
                    </div>
                    <div *ngIf="col.isLink"><a (click)="onClickLink(data)" class="text-blue cursor-pointer"
                        [title]="data[col.name] || ''">{{ data[col.name] }}</a></div>
                  </ng-container>
                </td>

                <!-- <td *ngIf="showSettingCol()"></td> -->
              </ng-container>
            </ng-container>
            <!-- phần form này chẳng bao giờ dùng -->
            <ng-template #editTemplate>
              <ng-container *ngIf="col.isInputAdd" [ngSwitch]="col.type">
                <td [nzLeft]="col?.pxLeft! ? col?.pxLeft! : false" [nzRight]="getFixRightPx(col)" class="text-center">
                  <ng-container *ngSwitchCase="COLUMN_TYPE.CHECKBOX">
                    <label nz-checkbox [(ngModel)]="editCache[data.id].data[col.name]" [nzDisabled]="col.isDisabled">
                    </label>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.NUMBER">
                    <vss-ui-input-number inputNumber [csPrecision]="col?.numberFixed || 2"
                      [csInputMode]="col?.typeNumber || 'numeric'"
                      [(ngModel)]="editCache[data.id].data[col.name]"></vss-ui-input-number>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.INPUT_NUMBER">
                    <vss-ui-input-number inputNumber [csPrecision]="col?.numberFixed || 2"
                      [csInputMode]="col?.typeNumber || 'numeric'"
                      [(ngModel)]="editCache[data.id].data[col.name]"></vss-ui-input-number>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.INT">
                    <nz-input-number type="number" [(ngModel)]="editCache[data.id].data[col.name]"></nz-input-number>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.DATE">
                    <vss-ui-date-picker dateFormat [(ngModel)]="editCache[data.id].data[col.name]"></vss-ui-date-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.DATE_PICKER">
                    <vss-ui-date-picker [ranges]="col.rangesDate" dateFormat
                      [(ngModel)]="editCache[data.id].data[col.name]"></vss-ui-date-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.DATE_TIME_PICKER">
                    <vss-ui-date-picker [ranges]="col.rangesDate" dateFormat
                      [(ngModel)]="editCache[data.id].data[col.name]"></vss-ui-date-picker>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SELECT">
                    <vss-ui-select-box [(ngModel)]="editCache[data.id].data[col.name]" class=""
                      [optionList]="col?.options || []" (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="!col?.multiple || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate">
                    </vss-ui-select-box>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SELECT_INT">
                    <vss-ui-select-box [(ngModel)]="editCache[data.id].data[col.name]" class=""
                      [optionList]="col?.options || []" (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="!col?.multiple || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate">
                    </vss-ui-select-box>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SELECT_IN_TD">
                    <vss-ui-select-box *ngIf="!isCheckDataSelectInt" [(ngModel)]="editCache[data.id].data[col.name]"
                      class="" [optionList]="col?.options || []"
                      (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="!col?.multiple || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate">
                    </vss-ui-select-box>
                    <vss-ui-select-box *ngIf="isCheckDataSelectInt"
                      [class]="!editCache[data.id].data[col.name] && isCheckSaveAddCategoryStaff ? 'fix_border_errors' : 'no_fix_border_errors'"
                      [(ngModel)]="editCache[data.id].data[col.name]" class="" [optionList]="col?.options || []"
                      (onClose)="col?.multiple ? onSelectChange($event, data) : null"
                      (ngModelChange)="!col?.multiple || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="placeholderSelect | translate"
                      (csOpenChange)="csOpenChange($event, col?.options, editCache[data.id].data[col.name])">
                    </vss-ui-select-box>
                    <span
                      *ngIf="isCheckDataSelectInt && !editCache[data.id].data[col.name] && isCheckSaveAddCategoryStaff"
                      style="color:var(--primary-color); font-size: 11px">{{'BASE.VALID_REQUIRE' | translate}}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TAG">
                    <vss-ui-select-box [(ngModel)]="editCache[data.id].data[col.name]" class=""
                      [optionList]="col?.options || col?.filter.options || []"
                      (onClose)="isArray(data[col.name]) ? onSelectChange($event, data) : null"
                      (ngModelChange)="!isArray(data[col.name]) || $event ? onSelectChange($event, data) : null; onChangeCol($event,col.name, data)"
                      [csMode]="col?.csSelectSettings?.multiple ? 'multiple' : 'default'"
                      [csMaxTagCount]="col?.csSelectSettings?.csMaxTagCount!"
                      [csAllowClear]="col?.csSelectSettings?.csAllowClear !== undefined ? col?.csSelectSettings?.csAllowClear! : true"
                      [csPlaceHolder]="col?.csSelectSettings?.placeholder || col.attr">
                    </vss-ui-select-box>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.TEXTAREA">
                    <textarea rows="4" nz-input [(ngModel)]="editCache[data.id].data[col.name]"></textarea>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.ACTION">
                    <a (click)="saveEditCache(data)" class="text-primary" nz-tooltip title="Lưu"> <i nz-icon
                        nzType="check" nzTheme="outline" aria-hidden="true"></i></a>
                    <nz-divider nzType="vertical"></nz-divider>
                    <a nz-popconfirm nzPopconfirmTitle="Bạn có muốn hủy ?" (nzOnConfirm)="cancelEditCache(data.id)"
                      nzCancelText='Không' nzOkText='Có' class="text-danger" nz-tooltip title="Hủy"><i nz-icon
                        nzType="close" nzTheme="outline" aria-hidden="true"></i></a>
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.TEXT_CENTER">
                    <input type="text" class="text-center" nz-input [(ngModel)]="editCache[data.id].data[col.name]" />
                  </ng-container>

                  <ng-container *ngSwitchCase="COLUMN_TYPE.SWITCH">
                    <div class="text-center">
                      <nz-switch [ngModel]="editCache[data.id].data[col.name]"
                        (ngModelChange)="onChangeSwitch($event, data)"></nz-switch>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="COLUMN_TYPE.SWITCH_NOT_ACTION">
                    <div class="text-center" style="pointer-events:none">
                      <nz-switch [ngModel]="editCache[data.id].data[col.name]"
                        (ngModelChange)="onChangeSwitch($event, data)"></nz-switch>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <input type="text" nz-input [(ngModel)]="editCache[data.id].data[col.name]" />
                  </ng-container>
                </td>
              </ng-container>
              <ng-container *ngIf="!col.isInputAdd">
                <td>{{editCache[data.id].data[col.name]}}</td>
              </ng-container>
            </ng-template>
          </ng-template>
        </tr>
      </ng-template>
    </tbody>
  </nz-table>
  <ng-template #loadingTpl>
    <tr>
      <td [attr.colspan]="getTotalColumnActive() || 1">
        <div class="text-center h2 p-3 table-loading">
          <i nz-icon [nzType]="'loading'" [nzSpin]="true" aria-hidden="true"></i>
        </div>
        <!--      <div class="placeholder-glow p-1">-->
        <!--        <span class="placeholder col-12"></span>-->
        <!--        <span class="placeholder col-10"></span>-->
        <!--        <span class="placeholder col-8"></span>-->
        <!--      </div>-->
      </td>
    </tr>
  </ng-template>
  <!-- <div *ngIf="!loadingDataTable && !dataFiltered?.length" class="text-center border">
    <nz-empty nzNotFoundContent="Không có bản ghi nào"></nz-empty>
  </div> -->
  <ng-template #noData>
    <nz-empty [nzNotFoundContent]="contentTpl"></nz-empty>
  </ng-template>
  <ng-template #contentTpl>
    <span>
      {{'BASE.NO_DATA' | translate}}
    </span>
  </ng-template>

  <div *ngIf="settingValue.pagination" class="" [class.px-3]="settingValue.paddingPagination">
    <vss-ui-pagination [pageSize]="paging.pageSize" (onPageSizeChange)="changePageSize($event)"
      (onPageIndexChange)="changePageIndex($event)" [totalItem]="paging.totalElements" [isShowSizeChanger]="true"
      [currentPage]="paging.pageIndex" [pageSizeOptions]="[10, 20, 50, 100]"
      *ngIf="checkPermissionData"></vss-ui-pagination>
    <vss-ui-pagination-2 [pageSize]="paging.pageSize" (onPageSizeChange)="changePageSize($event)"
      (onPageIndexChange)="changePageIndex($event)" [totalItem]="paging.totalElements" [isShowSizeChanger]="true"
      [currentPage]="paging.pageIndex" [pageSizeOptions]="[10, 20, 50, 100]"
      *ngIf="!checkPermissionData"></vss-ui-pagination-2>
  </div>
  <ng-template #totalTemplate let-total>{{'BASE.TOTAL' | translate}}: {{paging.totalElements}} {{'BASE.RECORD' | translate}}</ng-template>

  <ng-template #renderItemTemplate let-type let-page="page">
    <ng-container [ngSwitch]="type">
      <a *ngSwitchCase="'page'">{{ page }}</a>
      <a *ngSwitchCase="'prev'"><i nz-icon nzType="left" nzTheme="outline" class="fs-sm" aria-hidden="true"></i></a>
      <a *ngSwitchCase="'next'"><i nz-icon nzType="right" nzTheme="outline" aria-hidden="true"></i></a>
      <a *ngSwitchCase="'prev_5'"><i nz-icon nzType="left" nzTheme="outline" class="prev" aria-hidden="true"></i> <span
          class="ant-pagination-item-ellipsis">•••</span></a>
      <a *ngSwitchCase="'next_5'"><i nz-icon nzType="right" nzTheme="outline" class="next" aria-hidden="true"></i><span
          class="ant-pagination-item-ellipsis">•••</span></a>
    </ng-container>
  </ng-template>


  <vss-ui-notification-popup [isOpenModal]="openModalDelete" (onCloseModal)="openModalDelete = false" [isDelete]="true"
    (itemDeleteOk)="deleteOk($event)" [title]="'BASE.CONFIRM_DELETE_TITLE' | translate"
    [messageNotification]="confirmMessageDelete ? confirmMessageDelete : ('BASE.NOTIFICATION_MESS' | translate)"></vss-ui-notification-popup>
</div>
